import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorksStaffPaymentRatesNorms(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].GET_WORKS_STAFF_PAYMENT_RATES_NORMS,
        options
    )
}

function _getWorksStaffPaymentRatesNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].GET_WORKS_STAFF_PAYMENT_RATES_NORM,
        options
    )
}

function _createWorksStaffPaymentRatesNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].CREATE_WORKS_STAFF_PAYMENT_RATES_NORM,
        options
    )
}

function _putWorksStaffPaymentRatesNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].PUT_WORKS_STAFF_PAYMENT_RATES_NORM,
        options
    )
}

function _patchWorksStaffPaymentRatesNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].PATCH_WORKS_STAFF_PAYMENT_RATES_NORM,
        options
    )
}

function _deleteWorksStaffPaymentRatesNorm(options = {}) {
    return _apiRequestWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,
        ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].DELETE_WORKS_STAFF_PAYMENT_RATES_NORM,
        options
    )
}

export default {
    [ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].GET_WORKS_STAFF_PAYMENT_RATES_NORMS]: _getWorksStaffPaymentRatesNorms,
    [ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].GET_WORKS_STAFF_PAYMENT_RATES_NORM]: _getWorksStaffPaymentRatesNorm,
    [ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].CREATE_WORKS_STAFF_PAYMENT_RATES_NORM]: _createWorksStaffPaymentRatesNorm,
    [ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].PUT_WORKS_STAFF_PAYMENT_RATES_NORM]: _putWorksStaffPaymentRatesNorm,
    [ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].PATCH_WORKS_STAFF_PAYMENT_RATES_NORM]: _patchWorksStaffPaymentRatesNorm,
    [ModulesConfigMap[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].DELETE_WORKS_STAFF_PAYMENT_RATES_NORM]: _deleteWorksStaffPaymentRatesNorm,
}